import React, { Children, useEffect, useState } from 'react';
import Icon from '@iconify/react';
import iconChevronDown from '@iconify-icons/mdi/chevron-down';
import iconChevronUp from '@iconify-icons/mdi/chevron-up';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';
import BetaIcon, { IconSizes } from '../Icons/Icon';

const Accordion = ({
  isInitiallyOpen,
  leftIcon,
  label,
  items,
  children,
  onHeadClick,
  style,
  classNames,
  trackClicks = false,
}) => {
  children = Children.toArray(children);

  items = items.length > 0 ? items : children;
  const isOpenable = items.length > 0;
  const [isOpen, setIsOpen] = useState(isOpenable && isInitiallyOpen);

  // Update the accordion state when isInitiallyOpen changes
  // useEffect(() => {
  //   if (isOpenable) {
  //     setIsOpen(isInitiallyOpen);
  //   }
  // }, [isInitiallyOpen, isOpenable]);

  const toggleAccordion = () => setIsOpen(isOpenable && !isOpen);

  const handleClick = () => {
    // Track accordion opening (not closing) only when trackClicks is enabled
    if (isOpenable && !isOpen && trackClicks) {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('Accordion Clicked', {
          question: label,
          accordion_style: style,
          url: window.location.pathname
        });
      }
    }

    toggleAccordion();
    onHeadClick();
  };

  return (
    <div
      className={cn(
        'beta-accordion',
        `beta-accordion--${style} ${isOpen ? 'beta-accordion--open' : ''}`,
        classNames
      )}
    >
      <div
        className={`beta-accordion__head beta-accordion__head--${style}`}
        onClick={handleClick}
      >
        {leftIcon && (
          <div
            className={`beta-accordion__head__icon beta-accordion__head__icon--${style}`}
          >
            {leftIcon}
          </div>
        )}
        <div
          className={`beta-accordion__head__label ${isOpen
            ? `beta-accordion__head__label--open`
            : `beta-accordion__head__label--closed`
            }`}
        >
          {label}
        </div>
        {isOpenable && (
          <div
            className={cn(
              'beta-accordion__head__icon',
              `beta-accordion__head__icon--${style}`
            )}
          >
            {style === 'faq-primary' ||
              style === 'faq-secondary' ||
              style === 'faq-search' ? (
              <BetaIcon
                name={isOpen ? 'chevronUp' : 'chevronDown'}
                size={IconSizes[20]}
              />
            ) : (
              <Icon
                icon={isOpen ? iconChevronUp : iconChevronDown}
                className="icon"
              />
            )}
          </div>
        )}
      </div>
      <CSSTransition
        classNames="beta-accordion__body"
        in={isOpen}
        timeout={0}
        appear={true}
      >
        <div
          className={cn(
            'beta-accordion__body',
            `beta-accordion__body--${style}`,
            classNames
          )}
        >
          <div className={'beta-accordion__body__inner'}>{items}</div>
        </div>
      </CSSTransition>
      <div className={`beta-accordion__border--${style}`}></div>
    </div>
  );
};

export const AccordionStyles = {
  primary: 'primary',
  secondary: 'secondary',
  faqPrimary: 'faq-primary',
  faqSecondary: 'faq-secondary',
  faqSearch: 'faq-search',
  info: 'info',
};

Accordion.defaultProps = {
  items: [],
  isInitiallyOpen: false,
  style: AccordionStyles.primary,
  onHeadClick: () => { },
  leftIcon: null,
};

export default Accordion;
